import React, { useEffect, useState } from 'react';
import API from '../api';

export default function Analytics() {
  const [quoteData, setQuoteData] = useState([]);
  const [leadData,  setLeadData]  = useState([]);
  const [prodData,  setProdData]  = useState([]);

  useEffect(() => {
    (async () => {
      const [rq, rl, rp] = await Promise.all([
        API.get('/api/quote'),
        API.get('/api/leads'),
        API.get('/api/production'),
      ]);
      setQuoteData(rq.data || []);
      setLeadData (rl.data || []);
      setProdData (rp.data || []);
    })();
  }, []);

  if (!quoteData.length || !leadData.length || !prodData.length) {
    return <div style={{ padding: 20 }}>Loading analytics…</div>;
  }

  const hdrQ = quoteData[0], datQ = quoteData.slice(1);
  const sumSC = datQ
    .filter(r=>['Submitted','Completed'].includes(r[hdrQ.indexOf('Quote Status')]))
    .reduce((s,r)=>s+(+r[hdrQ.indexOf('Quote Value')]||0),0);
  const sumC  = datQ
    .filter(r=>r[hdrQ.indexOf('Quote Status')]==='Confirmed')
    .reduce((s,r)=>s+(+r[hdrQ.indexOf('Quote Value')]||0),0);

  const newLeads = leadData.length - 1;
  const hdrL     = leadData[0];
  const fullShops= leadData.slice(1)
    .filter(r=>r[hdrL.indexOf('Project Type')]==='Full Shop').length;

  const hdrP     = prodData[0], datP = prodData.slice(1);
  const prodVal  = datP.reduce((s,r)=>s+(+r[hdrP.indexOf('Quote Value')]||0),0);

  return (
    <div style={{ padding: 20 }}>
      <h2>Analytics</h2>
      <p>Total Submitted+Completed Quotes: AED {sumSC}</p>
      <p>Total Confirmed Quotes: AED {sumC}</p>
      <p>New Leads: {newLeads}</p>
      <p>Full Shops: {fullShops}</p>
      <p>Production Value: AED {prodVal}</p>
    </div>
  );
}
